import clsx from "clsx";

import { typedObjectEntries } from "common/helpers/utils";
import type { SubscriptionType } from "common/types";

import type { Dispatch, ReactNode, SetStateAction } from "react";

import OutreachAvatarIcon from "assets/icons/outreach-avatar.svg?react";
import OutreachSeatIcon from "assets/icons/outreach-seat.svg?react";

const subscriptionTypes: Record<
  SubscriptionType,
  { label: string; text: string; icon: ReactNode }
> = {
  user: {
    label: "Outreach seat",
    text: "Connect your LinkedIn profile and reach out to prospects right away",
    icon: <OutreachSeatIcon />,
  },
  rental: {
    label: "Outreach avatar",
    text: "Scale your LinkedIn efforts with rented accounts",
    icon: <OutreachAvatarIcon />,
  },
};

interface SubscriptionTypeCardsProps {
  subscriptionType: SubscriptionType;
  setSubscriptionType: Dispatch<SetStateAction<SubscriptionType>>;
}

export default function SubscriptionTypeCards({
  subscriptionType,
  setSubscriptionType,
}: SubscriptionTypeCardsProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-1 gap-3">
      {typedObjectEntries(subscriptionTypes).map(
        ([key, { label, text, icon }]) => {
          const isSelected = key === subscriptionType;

          return (
            <button
              key={key}
              className={clsx(
                "flex border rounded-3xl gap-x-2.5 p-3 transition-colors",
                isSelected
                  ? "bg-purple-50 border-purple-500"
                  : "bg-white border-black-200",
              )}
              type="button"
              onClick={() => setSubscriptionType(key)}
            >
              <span
                className={clsx(
                  "shrink-0 size-10 lg:size-11 transition-[background] rounded-xl inline-flex items-center justify-center",
                  isSelected ? "bg-white" : "bg-whiteGray",
                )}
              >
                {icon}
              </span>

              <div className="flex flex-col gap-y-1">
                <h3 className="text-sm-bold text-left">{label}</h3>
                <p className="text-xs-medium text-left text-black-500 max-lg:hidden">
                  {text}
                </p>
              </div>
            </button>
          );
        },
      )}
    </div>
  );
}
